import readSpEnv from "./read-sp-env";

const fallbackPath = '/WEB-IES/braunschweig-module/current/';

export default function getResourcePath() {
	return (readSpEnv('resourcesPath') || fallbackPath).replace(/\/?$/, '/');
}
